import Atendimento from "../entities/Atendimento";
import { handleError } from "../utils/errorhandler";
import ItemHistorico from "../entities/ItemHistorico";

function converterAnexos(anexos) {
    return anexos.map((arquivo) => {
        const index = arquivo.content.indexOf(",");

        return {
            contenttype: arquivo.type,
            filename: arquivo.name,
            content: arquivo.content.substring(index + 1),
        };
    });
}

export default class ServicoAtendimento {
    constructor({ store, router, mapaProcessadores, api }) {
        this.store = store;
        this.router = router;
        this.mapaProcessadores = mapaProcessadores;
        this.api = api;
        this.cancelToken = null;
    }

    getArvores(busca, contextoId) {
        if (this.cancelToken) {
            this.api.cancelGetRequest(this.cancelToken);
        }
        this.cancelToken = this.api.createCancelToken();

        if (busca && busca.trim().length > 0) {
            return this.api
                .get(
                    `/api/arvores?busca=${encodeURIComponent(
                        busca.trim(),
                    )}&contextoId=${contextoId}`,
                    this.cancelToken,
                )
                .then((response) => response?.data?.arvores);
        }
        return this.api
            .get(`/api/arvores?contextoId=${contextoId}`)
            .then((response) => response?.data?.arvores);
    }

    atendimentoEmAberto() {
        return this.store.getters["atendimento/emAberto"];
    }

    iniciarAtendimento(id, contextoId) {
        return this.api
            .get(`/api/arvores/${id}?contextoId=${contextoId}`)
            .then((response) => response.data)
            .then((arvore) => {
                var atendimento = new Atendimento(arvore);
                this.store.commit(
                    "atendimento/" + "SALVAR_ATENDIMENTO",
                    atendimento,
                );
            })
            .catch((error) => {
                handleError(this.router, error);
            });
    }

    getArvorePorId(id, contextoId) {
        return this.api
            .get(`/api/arvores/${id}?contextoId=${contextoId}`)
            .then((response) => response.data);
    }

    chamadoFechado() {
        return (
            "state" in this.atribuicoes() &&
            this.atribuicoes()["state"] == "closed successful"
        );
    }

    encerrarAtendimento(ticketId) {
        const fechado = this.chamadoFechado();
        this.store.commit("atendimento/" + "SALVAR_ATENDIMENTO", null);
        if (fechado) {
            // this.router.push(`/atendimento`);
            console.log("Chamado fechado com sucesso");
        } else {
            this.router.push(`/chamados/detalhe/${ticketId}`);
        }
    }

    nomeTelaAtual() {
        return this.store.getters["atendimento/nomeTelaAtual"];
    }

    telaAtual() {
        return this.store.getters["atendimento/telaAtual"];
    }

    getDados() {
        return this.store.getters["atendimento/dados"];
    }

    atribuicoes() {
        return this.store.getters["atendimento/atribuicoes"];
    }

    log() {
        return this.store.getters["atendimento/log"];
    }

    criarItemHistorico({ dados, atribuicoes, log }) {
        const copiaDados = Object.assign({}, dados);
        const copiaAtribuicoes = Object.assign({}, atribuicoes);
        const copiaLog = Object.assign([], log);
        return new ItemHistorico({
            nomeTela: this.nomeTelaAtual(),
            dados: copiaDados,
            atribuicoes: copiaAtribuicoes,
            log: copiaLog,
        });
    }

    async processarTela(dados) {
        const processador = this.mapaProcessadores[this.telaAtual().tipo];
        const atribuicoes = { ...this.atribuicoes() };
        const item = this.criarItemHistorico({
            dados,
            atribuicoes,
            log: this.log(),
        });
        const tela = this.telaAtual();
        const proximaTela = await processador.processar({
            dados,
            tela,
            atribuicoes,
        });
        const log = [...this.log(), proximaTela];
        this.store.commit("atendimento/" + "ATUALIZAR_TELA_ATUAL", {
            proximaTela,
            item,
            atribuicoes,
            log,
        });
    }

    voltar() {
        this.store.commit("atendimento/" + "VOLTAR");
    }

    cancelar() {
        this.store.commit("atendimento/" + "SALVAR_ATENDIMENTO", null);
    }

    criarChamado() {
        let anexos = [];
        if (this.atribuicoes()["__anexos"]) {
            anexos = converterAnexos(this.atribuicoes()["__anexos"]);
            delete this.atribuicoes()["__anexos"];
        }

        const props = Object.fromEntries(
            Object.entries(this.atribuicoes()).filter(
                ([key, value]) =>
                    key !== "__anexos" &&
                    value !== undefined &&
                    value != null &&
                    value.constructor !== Array,
            ),
        );

        const now = new Date();
        const propriedades = {
            assunto: `Chamado criado automaticamente - ${now.toLocaleString()}`,
            fila: "N1::Service Desk",
            tipo: "Requisição de Serviço",
            prioridade: "5 Muito Alto",
            ...props,
        };

        const tabelas = Object.fromEntries(
            Object.entries(this.atribuicoes()).filter(
                ([key, value]) =>
                    key !== "__anexos" &&
                    value !== undefined &&
                    value != null &&
                    value.constructor === Array,
            ),
        );

        const headers = {
            "Content-Type": "application/json",
        };

        const contextoId = this.store.getters["contexto/contexto"]?.id;

        const data = {
            contextoId,
            propriedades,
            anexos,
            tabelas,
            log: this.log(),
        };

        console.log("Criando chamado...", data);

        return this.api
            .post("/api/ticket", data, { headers })
            .then((response) => {
                console.log("Chamado criado", response);
                return response.data;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }
}
